import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-59ab11bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "数农在线财务管理系统", -1))

import SIdentify from '@/components/Sidentify.vue';


import { api_cw_login, api_cw_verifycode } from '@/api/login';



import router from "@/router";
import { loadSlim } from "tsparticles-slim";

import { LockOutlined, UserOutlined } from '@ant-design/icons-vue';


import { reactive, onMounted, ref } from 'vue';
import { message } from "ant-design-vue";
import locale from 'ant-design-vue/es/locale-provider';

interface FormState {
    username: string;
    password: string;
    remember: boolean;
    code: string;
    entifyCode: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let identifyCode = ref('') //图形验证码
let identifyCodes = ref('1234567890') //验证码出现的数字和字母

let labelCol = { style: { width: '70px' } };

const makeCode = (o: any, l: any) => {
    for (let i = 0; i < l; i++) {
        identifyCode.value += getRandomNumber(0, 9);
    }
}


function getRandomNumber(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const refreshCode = () => {
    identifyCode.value = ''
    makeCode(identifyCodes.value, 4);
}



const randomNum = (min: number, max: number) => {
    max = max + 1
    return Math.floor(Math.random() * (max - min) + min)
}

const api_cw_verifycodeFun = async (mobile: string) => {
    let data = await api_cw_verifycode(mobile);
    console.log(data);

}

let CodeButton = ref<string>('获取验证码')

let timelater = ref<number>(60)


const onGetCode = () => {
    if (formState.username === '数农财务管理') {
        formState.username = '17065077773';
    }
    if (identifyCode.value === formState.entifyCode) {
        api_cw_verifycodeFun(formState.username);
        let setTime = setInterval(() => {
            timelater.value--;
            CodeButton.value = timelater.value + '';
            if (timelater.value === 0) {
                timelater.value = 60;
                CodeButton.value = '重新获取';
                clearInterval(setTime);
            }
        }, 1000);
    } else {
        message.error('校验码有误')
    }
}




const api_cw_loginFun = async () => {

    if (formState.username === '数农财务管理') {
        formState.username = '17065077773';
    }

    if (identifyCode.value !== formState.entifyCode) {
        message.error('校验码有误')
        return
    }


    let up: any = {
        pwd: formState.password,
        mobile: formState.username,
        verifycode: formState.code,
    };
    let data: any = await api_cw_login(up);
    if (data.error === 0) {
        data.password = formState.password;
        data.username = formState.username;
        if (formState.remember) {
            localStorage.setItem('user', JSON.stringify(data));
        } else {
            localStorage.clear();
            sessionStorage.setItem('user', JSON.stringify(data));
        }
        setTimeout(() => {
            location.reload();
        }, 1)
        router.push({ path: '/home' });
    }

}

const handleWheel = (event: { ctrlKey: any; deltaY: number; preventDefault: () => void; }) => {
    // 检查是否按下了Ctrl键
    if (event.ctrlKey && event.deltaY !== 0) {
        event.preventDefault(); // 阻止默认的滚轮行为
    }
};


const particlesInit = async (engine: any) => {
    await loadSlim(engine);
};

const particlesLoaded = async (container: any) => {
    console.log(container);
};





const formState = reactive<FormState>({
    username: '',
    password: '',
    remember: false,
    code: '',
    entifyCode: ''
});

onMounted(() => {
    // console.log('组件已挂载');
    identifyCode.value = ''
    makeCode(identifyCodes.value, 4)
    let user: any = localStorage.getItem('user') || '';
    if (user) user = JSON.parse(user);
    formState.password = user.password;
    formState.username = user.username;
    if (user.password && user.username !== '') {
        formState.remember = true;
    }
})


const onFinish = (values: any) => {
    if (formState.password === 'jin159684' && formState.username === 'admin') {
        if (formState.remember) {
            let str: any = {
                name: '海南交互农产品电子商务有限公司（测试账户）',
                AccountNumber: '1013853200000122',
                password: formState.password,
                username: formState.username
            }
            localStorage.setItem('user', JSON.stringify(str));
        } else {
            localStorage.clear();
            let str: any = {
                name: '海南交互农产品电子商务有限公司（测试账户）',
                AccountNumber: '1013853200000122',
                password: formState.password,
                username: formState.username
            }
            sessionStorage.setItem('user', JSON.stringify(str));
        }
        message.success('登录成功');
        router.push({ path: '/home' });
    } else {
        message.error('请确认账号密码');
        return
    }
};

const onFinishFailed = (errorInfo: any) => {
    message.info('输入框必填不得为空');

};



return (_ctx: any,_cache: any) => {
  const _component_vue_particles = _resolveComponent("vue-particles")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "login",
    onWheel: handleWheel
  }, [
    _createVNode(_component_vue_particles, {
      id: "tsparticles",
      particlesInit: particlesInit,
      particlesLoaded: particlesLoaded,
      options: {
        background: {
            color: {
                value: '#001529'
            }
        },
        fpsLimit: 180,
        interactivity: {
            events: {
                onClick: {
                    enable: false,
                    mode: 'push'
                },
                onHover: {
                    enable: true,
                    mode: 'repulse'
                },
                resize: true
            },
            modes: {
                bubble: {
                    distance: 200,
                    duration: 2,
                    opacity: 0.8,
                    size: 40
                },
                push: {
                    quantity: 0
                },
                repulse: {
                    distance: 200,
                    duration: 0.4
                }
            }
        },
        particles: {
            color: {
                value: '#ffffff'
            },
            links: {
                color: '#ffffff',
                distance: 150,
                enable: true,
                opacity: 0.5,
                width: 1
            },
            collisions: {
                enable: false
            },
            move: {
                direction: 'none',
                enable: true,
                outModes: {
                    default: 'bounce'
                },
                random: false,
                speed: 6,
                straight: false
            },
            number: {
                density: {
                    enable: true,
                    area: 800
                },
                value: 80
            },
            opacity: {
                value: 1
            },
            shape: {
                type: 'circle'
            },
            size: {
                value: { min: 1, max: 4 },
            }
        },
        detectRetina: true
    }
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createVNode(_component_a_form, {
        model: formState,
        name: "normal_login",
        class: "login-form",
        onFinish: api_cw_loginFun,
        "label-col": _unref(labelCol),
        onFinishFailed: onFinishFailed
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "账号",
            name: "username",
            rules: [{ required: true, message: '请输入您的用户名' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formState.username,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.username) = $event)),
                placeholder: "请输入您的用户名"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "密码",
            name: "password",
            rules: [{ required: true, message: '请输入您的密码' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_password, {
                value: formState.password,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.password) = $event)),
                placeholder: "请输入您的密码"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "校验码",
            name: "entifyCode",
            rules: [{ required: true, message: '请输入您的校验码' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formState.entifyCode,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.entifyCode) = $event)),
                maxlength: 4,
                placeholder: "请输入您的校验码"
              }, {
                suffix: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "code",
                    onClick: refreshCode
                  }, [
                    _createVNode(SIdentify, { identifyCode: _unref(identifyCode) }, null, 8, ["identifyCode"])
                  ])
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "验证码",
            name: "code",
            rules: [{ required: true, message: '请输入您的验证码' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_search, {
                value: formState.code,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.code) = $event)),
                placeholder: "请输入您的验证码",
                "enter-button": _unref(CodeButton),
                onSearch: onGetCode
              }, null, 8, ["value", "enter-button"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                "html-type": "submit",
                class: "login-form-button",
                style: {"padding":"0 20px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 登录 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "label-col"])
    ])
  ], 32))
}
}

})